(() => {
if (customElements.get('liora-image-comparison')) return;
customElements.define('liora-image-comparison', class extends HTMLElement {
connectedCallback() {
if (this.initialized) return;
const range = this.querySelector('input[type="range"]');
if (!range) return;
this.initialized = true;
const update = value => {
range.value = String(Math.round(Math.max(0, Math.min(100, value))));
this.style.setProperty('--comparison-position', range.value + '%');
range.setAttribute('aria-valuetext', (100 - Number(range.value)) + '% ' + (range.dataset.afterDescription || 'אחרי ההתקנה'));
};
const move = event => {const bounds=this.getBoundingClientRect();if(bounds.width) update((event.clientX-bounds.left)/bounds.width*100)};
range.addEventListener('input', () => update(Number(range.value)));
range.addEventListener('pointerdown', event => {if(!event.isPrimary || event.button!==0) return;event.preventDefault();range.focus({preventScroll:true});this.activePointer=event.pointerId;range.setPointerCapture(event.pointerId);move(event)});
range.addEventListener('pointermove', event => {if(this.activePointer===event.pointerId) move(event)});
const end=()=>{this.activePointer=null};
range.addEventListener('pointerup',end);range.addEventListener('pointercancel',end);range.addEventListener('lostpointercapture',end);
update(Number(range.value));
}
});
})();
